import { Box, Card, CardContent, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { AppMisc } from '../../../misc/appMisc';
import { AppUtils } from '../../../utils/appUtils';
import { GENDER_OPTIONS } from '../../../utils/constants';
import { getHealthClientAndPalikaInfoData } from "../../../action/HealthClientInfo";
import HealthServiceCardHeader from "../../../pages/users/components/health-service-card-header/HealthServiceCardHeader";
import { useEffect } from "react";
import styles from "./style";

const ReferredOutSlip = ({ patientData, printComponentRef }) => {
  const healthClientInfo = useSelector(state => state.healthClientInfo);
  const dispatch = useDispatch();
  const classes = styles();

  useEffect(() => {
    !healthClientInfo && dispatch(getHealthClientAndPalikaInfoData());
  }, [healthClientInfo])

  return (
    <>
      <Box mt={3}>
        <Card>
          <CardContent>
            <Box margin={2}>
              <Box ref={printComponentRef}>
                <HealthServiceCardHeader healthPostName={healthClientInfo?.name} municipality={healthClientInfo?.palikaName} district={healthClientInfo?.district && AppMisc.getDistrictName(healthClientInfo.district)} />
                <Grid spacing={2} container>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1">प्रेषण/स्थानान्तरण पूर्जा</Typography>
                    <Divider />
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    सेवाग्राहीको नाम, थर: {`${patientData.patientFirstName} ${patientData.patientLastName}`}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    लिङ्ग: {patientData?.gender ? AppMisc.findLabelFromValue(GENDER_OPTIONS, patientData.gender) : "-"}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    उमेर: {patientData?.age ? AppUtils.replaceWithNepaliDigit(patientData.age) + " " + AppMisc.getAgeUnitLabel(patientData.ageUnit) : "-"}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    जिल्ला: {patientData?.district ? AppMisc.getDistrictName(patientData.district) : "-"}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    न.पा./गा. पा.: {patientData?.palikaName ? AppMisc.getMunicipalityName(patientData.palikaName) : "-"}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    वडा नं.: {patientData?.wardNumber ? AppUtils.replaceWithNepaliDigit(patientData.wardNumber) : "-"}
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>
                    सम्पर्क नं.: {patientData?.phoneNumber ? AppUtils.replaceWithNepaliDigit(patientData.phoneNumber) : "-"}
                  </Grid>
                </Grid>
                <Box pt={2}>
                  <TableContainer classes={{ root: "fixed-head-table-container" }}>
                    <Table classes={{ root: " normal-spacing" }} size="small" style={{ width: "100%" }}>
                      <TableHead classes={{ root: "align-center header-sm" }}>
                        <TableRow>
                          <TableCell>Pulse</TableCell>
                          <TableCell>Temprature</TableCell>
                          <TableCell>Blood Pressure</TableCell>
                          <TableCell>Respiration</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody className="align-center">
                        <TableRow>
                          <TableCell>{patientData?.pulseRate ? `${patientData.pulseRate} bpm` : "-"}</TableCell>
                          <TableCell>{patientData?.temperature ? `${AppUtils.replaceWithNepaliDigit(patientData.temperature)}°C` : "-"}</TableCell>
                          <TableCell>{patientData?.bloodPressure ? patientData?.bloodPressure : "-"}</TableCell>
                          <TableCell>{patientData?.respPerMin ? `${patientData.respPerMin}` : "-"}</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell>उपचार विधि वा रेजिमेन:</TableCell>
                            <TableCell>...............</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>प्रयोग भएको औषधी:</TableCell>
                            <TableCell>...............</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>अन्य परिक्षण गर्नपर्ने भए उल्लेख गर्ने:</TableCell>
                            <TableCell>...............</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Box>
                      <Table>
                        <TableHead>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell>स्थानान्तरण / प्रेषण गरिनुको कारण:</TableCell>
                            <TableCell>...............</TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell>अन्य केही भए उल्लेख गर्ने:</TableCell>
                            <TableCell>...............</TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Box>
                  </Grid>
                </Grid>
                <Box marginY={2} >
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography>श्री {patientData?.referredIn}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography>
                        यस संस्थामा सेवा लिन आएका उपरोक्त विवरण भएका व्यक्तिलाई आवश्यक सेवाका लागि तपाईकोमा पठाएको छ।
                        आवश्यक परेमा यससँग सम्बन्धित जानकारी पठाई दिन हुन अनुरोध छ।
                      </Typography>
                    </Grid>
                  </Grid>

                  <Divider className={classes.divider} />
                  <TableContainer>
                    <Table size="small">
                      <TableBody>
                        <TableRow>
                          <TableCell contentEditable>प्रेषण / स्थानान्तरण गर्नेको नाम:</TableCell>
                          <TableCell contentEditable>पद:</TableCell>
                          <TableCell contentEditable>सही:</TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Box mt={3}>
                    <Typography variant="body2" align="center">
                      नोट: सेवा लिन आउने बिरामीहरूलाई उपलब्ध सेवाको लोकेसन सेवाको लिस्ट अनुसार गर्ने। स्थानान्तरण प्रेषण गर्दा यो फाराम प्रयोग गर्नुपर्ने।
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box >
    </>
  );
};

export default ReferredOutSlip;
